import { ReactNode } from "react";
import { Type } from "@themes/pollinator/ui/Type";
import { DonutChart, type DonutChartDataItem } from "@themes/pollinator/ui/DonutChart";
import { useBreakpoint } from "@core/hooks/useBreakpoint";

export type Props = {
  title: string;
  data: DonutChartDataItem[];
  showLegend?: boolean;
  showPercentage?: boolean;
  showCenterLabel?: boolean;
  isPercentageMeter?: boolean;
  children?: ReactNode;
};

export function TrackingMetricItem({
  title,
  data,
  showLegend = false,
  showPercentage = false,
  showCenterLabel = false,
  isPercentageMeter = false,
  children,
}: Props) {
  const isMobile = useBreakpoint("md");

  return (
    <div className="flex flex-col gap-4 items-start">
      <Type variant="h5" as="h3">
        {title}
      </Type>
      <DonutChart
        data={data}
        showCenterLabel={showCenterLabel}
        isPercentageMeter={isPercentageMeter}
        size={isMobile ? 160 : 200}
        showLegend={showLegend}
        showPercentage={showPercentage}
        legendPosition={isMobile ? "bottom" : "right"}
      >
        {children}
      </DonutChart>
    </div>
  );
}

export default TrackingMetricItem;

